import React, { useEffect, useState } from "react";
import api from "../api/api";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../context/AuthContext";
import { Send, Loader, Link } from "react-feather";
import { useTranslation } from "react-i18next";
const Share = (prop) => {
  const { user } = useAuth();
  const [selectedEmployer, setSelectedEmployer] = useState([]);
  const [employers, setEmployers] = useState([]);
  const [originalEmployers, setOriginalEmployers] = useState([]);
  const [loadingSendInv, setLoadingSendInv] = useState(false);
  const [successMessage, setSuccessMessage] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const { t } = useTranslation();
  // Form validation schema
  const schema = yup.object({
    employer_id: yup
      .array()
      .min(1, "Please select at least one agency")
      .required("At least one agency is required"),
  });

  const {
    reset,
    handleSubmit,
    register,
    setError,
    setValue, // Added setValue here
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // Fetch employers list
  const fetchDataEmployers = async () => {
    clearErrors();
    setErrorMessage(null);
    
    try {
      const response = await api.get('/agency-employer-list');

      if (response.status === 200 && Array.isArray(response.data.data)) {
        setEmployers(response.data.data);
        setOriginalEmployers(response.data.data);
      } else {
        setErrorMessage("Failed to load employers list");
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Error fetching employers");
      console.error("Error fetching employers:", error);
    }
  };

  // Handle checkbox changes
  const handleCheckboxChange = (agencyId) => {
    const newSelection = selectedEmployer.includes(agencyId)
      ? selectedEmployer.filter(id => id !== agencyId)
      : [...selectedEmployer, agencyId];
    
    setSelectedEmployer(newSelection);
    // Update form value for validation
    setValue("employer_id", newSelection); // Now properly defined
  };


  // Submit handler
  const onSubmit = async (data) => {
    setLoadingSendInv(true);
    setSuccessMessage([]);
    setErrorMessage(null);
    
    try {
      const response = await api.post('/agency-employer-list/', {
        selected_biodata: prop.selectedBiodata,
        employer_relations_ids: selectedEmployer,
        // Add any additional data you need to send
      });

      if (response.status === 201) {
        // setSuccessMessage(`URL: ${response.data.url}`);
        response.data.data.forEach((item) => {
          setSuccessMessage((prev) => [...prev, item]);
        })
        // Reset form after successful submission
        setSelectedEmployer([]);
        reset();
      } else {
        setErrorMessage(response.data?.message || "Failed to send broadcast");
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Error sending broadcast");
      console.error("Share error:", error);
    } finally {
      setLoadingSendInv(false);
    }
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    
     if(searchTerm) {
        // filter employers name, email, and phone
        const filteredEmployers = originalEmployers.filter(employe =>
          employe.name.toLowerCase().includes(searchTerm) ||
          employe.email.toLowerCase().includes(searchTerm) ||
          employe.phone.toLowerCase().includes(searchTerm)
        );
        setEmployers(filteredEmployers);
     } else {
        // Reset to original employers list if search term is empty
        setEmployers(originalEmployers);
     }
  };

  useEffect(() => {
    if (!prop.isOpen) return;
    fetchDataEmployers();
  }, [prop.isOpen]);

  return (
    <div className="modal custom-modal modal-lg fade" id="share_modal" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <div className="form-header modal-header-title text-start mb-0">
              <h4 className="mb-0">{t("Share")}</h4>
            </div>
            <button 
              type="button" 
              className="btn-close" 
              data-bs-dismiss="modal" 
              aria-label="Close"
              onClick={() => {
                setSuccessMessage(null);
                setErrorMessage(null);
              }}
            ></button>
          </div>
          
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 mx-1">
                  <div className="card-body">
                    <div className="form-groups-item">
                      {/* Agency Selection */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-block">
                            {/* Search Bar */}
                                <div className="mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder={t("Search for an employer by name, email, or phone")}
                                    onChange={handleSearch}
                                  />
                                </div>

                            {employers.length > 0 ? (
                              <div>
                                <div className="employer-list" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                  {employers.map(employe => (
                                    <div key={employe.relation_id} className="form-check mb-2 py-2 border rounded d-flex align-items-center">
                                      <input
                                        className="form-check-input me-2 form-control"
                                        type="checkbox"
                                        id={`employe-${employe.relation_id}`}
                                        checked={selectedEmployer.includes(employe.relation_id)}
                                        onChange={() => handleCheckboxChange(employe.relation_id)}
                                      />
                                      <label className="form-check-label" htmlFor={`employe-${employe.relation_id}`}>
                                        <strong>{employe.name}</strong>
                                        <div className="text-muted small">{employe.phone}</div>
                                      </label>
                                    </div>
                                  ))}
                                </div>
                                {errors.employer_id && (
                                  <small className="text-danger">{errors.employer_id.message}</small>
                                )}
                              </div>
                            ) : (
                              <div className="text-muted">{t("You don't have any employer yet.")}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="modal-footer">
             
            {successMessage && ( <small  style={{color:"green"}}>
                {successMessage.map((item, index) => (
                  <ul key={index} className="list-group">
                    {/* {item.name}: {item.url} */}
                    <li className="list-group-item mt-2">
                      <strong>{item.name}</strong>: {item.url}
                      <a href={item.url} target="_blank" rel="noopener noreferrer" className="btn btn-link">Open</a>
                      <button type="button" className="btn btn-link"
                        onClick={() => {
                          navigator.clipboard.writeText(item.url);
                          alert("Link copied to clipboard!");
                        }}
                      >
                        {t("Copy")}
                      </button>
                    </li>
                  </ul>
                ))}
                </small> )}
             
             
                {errorMessage && (<small  style={{color:"red"}}>
                {errorMessage}
                </small> )} 
             
                <div className="d-flex justify-content-end w-100 mt-2">
              <button 
                type="button" 
                data-bs-dismiss="modal" 
                className="btn btn-back cancel-btn me-2"
                onClick={() => {
                  setSuccessMessage(null);
                  setErrorMessage(null);
                }}
              >
                {t("Cancel")}
              </button>
              
              <button 
                type="submit" 
                disabled={loadingSendInv || selectedEmployer.length === 0}
                className="btn btn-primary"
              >
                {loadingSendInv ? (
                  <>
                   {t("Sending...")} <Loader className="spinner-border spinner-border-sm" />
                  </>
                ) : (
                  <>
                    {t("Generate Link")} <Link />
                  </>
                )}
              </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Share;